/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc>): BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc(), model);
        BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc>): BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.newInstance(<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
